'use client';
import e from 'prop-types';
import { createComponent } from '../core/create-component.js';

let n = {
    width: e.oneOf([
        'standard',
        'narrow'
    ])
};
const SkeletonTextLine = createComponent({
    displayName: 'SkeletonTextLine',
    root: 'div',
    propTypes: n,
    propConfig: {
        classNames (e) {
            let { width: t = 'standard' } = e, n = new Set([
                'swan-skeleton-text-line swan-loading-shimmer'
            ]);
            return 'narrow' === t && n.add("swan-skeleton-text-line-narrow"), n;
        }
    }
});

export { SkeletonTextLine };
